import React from "react";
import { useState } from "react";
import TitleSection from "../components/titleSection/TitleSection";
import Btn from "../components/button/Btn";
import CustomShape from '../components/customShape/customShape';
import Bento from "../components/bento/Bento";
import TechSection from "../components/techSection/TechSection";
import ReferenceSection from "../components/referenceSection/ReferenceSection";
import ContentNav from "../components/contentNav/ContentNav";
import ReferencesSlider from "../components/referencesSlider/ReferencesSlider";

const Home = () => {
    return (
        <div>
            <div className="landing-section" id="home">
                <div className="left-container">
                    <div className="left-wrapper">
                        <h3 className="inter md-text">Hello, I'm Honza</h3>
                        <h1 className="manrope xxl-text">Born to design & develop webs.</h1>
                        <h3 className="inter md-text">
                            Frontend Developer with a keen eye for design, skilled in React/Next.js and focused on clean UI.
                        </h3>
                    </div>
                    <div className="button-wrapper">
                        <Btn onClick={() => (window.location.href = "mailto:h.skrzeczek@gmail.com?subject=Interest in establishing cooperation.&body=More details...")} size='lg'>Hire Me!</Btn>
                    </div>
                </div>
                <div className="right-container">
                    <CustomShape />
                </div>
            </div>
            <ContentNav />
            <div className="section" id="my-stack">
                <TitleSection text="Technologies" />
                <div className="tech-container">
                    <TechSection title="FRAMEWORKS" content="Experience in React.Js and Vue.js" icon="/assets/reactIcon.svg" />
                    <TechSection title="Express.Js" content="Knowledge of Express.Js" icon="/assets/nodeIcon.svg" />
                    <TechSection title="TYPESCRIPT" content="Knowledge of strict data types." icon="/assets/tsIcon.svg" />
                </div>
            </div>
            <div className="section" id="about-me">
                <TitleSection text="My Capabilities" />
                <Bento />
            </div>
            <div className="section" id="references">
                <TitleSection text="Career" />
                <div className="references-container">

                    <ReferenceSection
                        title="Boliga.cz"
                        content="Boliga.cz is a web app designed for amateur badminton players to organize, manage, and compete in league matches effortlessly."
                        image="/assets/boliga.png"
                        imagePosition="left"
                    />

                    <ReferenceSection
                        title="Fantasy-academy.com"
                        content="Fantasy Academy is the ultimate platform for football enthusiasts looking to master the art of strategic betting. The platform focuses on analytics, strategy, and long-term improvement."
                        image="/assets/progress.png"
                        imagePosition="right"
                    />

                    <ReferenceSection
                        title="Bohemia Interactive"
                        content="As a QA at Bohemia Interactive, I contributed to the development of immersive games by ensuring quality and stability across builds. From exploratory testing to regression checks, I helped maintain a high player experience standard."
                        image="/assets/bohemia.png"
                        imagePosition="left"
                    />
                    <ReferenceSection
                        title="Meta Front-End developer certificate"
                        content="I completed the Meta Front-End Developer Professional Certificate, gaining practical skills in modern responsive web development."
                        image="/assets/meta.png"
                        imagePosition="right"
                    />
                </div>
            </div>
        </div>
    );
}

export default Home;